/** Direct Meili search client. We bypass instant-meilisearch's full
 *  InstantSearch machinery for v1 — our SPA is small enough that a thin
 *  wrapper around the meilisearch JS client is cleaner. */

import { MeiliSearch, type SearchResponse } from "meilisearch";

import { loadConfig } from "./config.js";
import type { SearchDoc, PostType } from "./schema.js";

export interface SearchParams {
  query: string;
  postTypes?: PostType[] | null;
  country?: string;
  skiAbility?: string;
  limit?: number;
  offset?: number;
}

export type SearchResults = SearchResponse<SearchDoc>;

let client: MeiliSearch | null = null;

function getClient(): MeiliSearch {
  if (!client) {
    const cfg = loadConfig();
    client = new MeiliSearch({ host: cfg.host, apiKey: cfg.searchKey });
  }
  return client;
}

export async function search(params: SearchParams): Promise<SearchResults> {
  const cfg = loadConfig();
  const index = getClient().index<SearchDoc>(cfg.indexName);

  const filterParts: string[] = [];
  if (params.postTypes && params.postTypes.length > 0) {
    const list = params.postTypes.map((t) => `"${t}"`).join(", ");
    filterParts.push(`post_type IN [${list}]`);
  }
  if (params.country) {
    filterParts.push(`taxonomies.country = "${params.country.replace(/"/g, "")}"`);
  }
  if (params.skiAbility) {
    filterParts.push(`taxonomies.ski_ability = "${params.skiAbility.replace(/"/g, "")}"`);
  }

  return index.search(params.query, {
    limit: params.limit ?? 20,
    offset: params.offset ?? 0,
    filter: filterParts.length > 0 ? filterParts.join(" AND ") : undefined,
    attributesToHighlight: ["title", "excerpt"],
    highlightPreTag: "<mark>",
    highlightPostTag: "</mark>",
    showRankingScore: false,
  });
}
